import { Component, EventEmitter, Input, type OnChanges, Output, type SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidationService } from '@services/ui/validation.service';
import { ButtonComponent } from '@shared/components/button/button.component';
import { InputComponent } from '@shared/components/input/input.component';
import { SharedModule } from '@shared/modules/shared.module';

@Component({
	selector: 'app-forgot-password-modal',
	imports: [SharedModule, InputComponent, ButtonComponent],
	templateUrl: './forgot-password-modal.component.html',
	styleUrl: './forgot-password-modal.component.scss',
})
export class ForgotPasswordModalComponent implements OnChanges {
	@Input() show = false;
	@Output() showChange = new EventEmitter<boolean>();
	@Output() submit = new EventEmitter<string>();

	forgotForm: FormGroup;

	constructor(
		private fb: FormBuilder,
		private validationService: ValidationService,
	) {
		this.forgotForm = this.fb.group({
			email: ['', [Validators.required, this.validationService.emailValidator()]],
		});
	}

	/**
	 * One-shot per opening: a fast double click used to emit twice before the
	 * parent closed the modal — two reset emails for one intent. Re-armed when
	 * the modal is opened again (never on close: the second click of the double
	 * arrives after the close it triggered).
	 */
	private submitted = false;

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['show'] && this.show) {
			this.submitted = false;
		}
	}

	onSubmit(): void {
		if (this.submitted) {
			return;
		}
		if (this.forgotForm.valid) {
			this.submitted = true;
			this.submit.emit(this.forgotForm.get('email')?.value);
			this.showChange.emit(false);
		} else {
			this.forgotForm.markAllAsTouched();
		}
	}

	onClose(): void {
		this.showChange.emit(false);
	}

	getErrorMessage(fieldName: string): string {
		const control = this.forgotForm.get(fieldName);
		if (!control?.errors || !control.touched) return '';

		const errorKey = Object.keys(control.errors)[0];
		return errorKey ? this.validationService.getValidatorErrorMessage(errorKey) : '';
	}
}
